import { CardContent } from '@mui/material';
import React from 'react';

export const PaywallCardPlan = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  return (
    <CardContent
      sx={{
        minHeight: 56,
        display: 'flex',
        alignItems: 'center',
      }}
    >
      {children}
    </CardContent>
  );
};
